export const BILLINGINQUIRY_FILE = 'BILLINGINQUIRY_FILE';
// 更新
export const BILLINGINQUIRY_UPDATE = 'BILLINGINQUIRY_UPDATE';
